import SectionHeading from "./SectionHeading";
import { quotes } from "@/mocks/quotes";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <SectionHeading
              align="left"
              eyebrow="关于我们"
              title="我们相信，理性是可以被训练的能力"
              desc="求真核查站由一群关注信息素养的编辑与核查员共同维护，只做一件事：把流传的在线黑料放到放大镜下，交给信源、证据和时间去检验。"
            />
            <ul className="space-y-3 mt-2">
              {[
                "只陈述可查证的事实，不制造「新料」",
                "结论透明可复核，欢迎读者提出新证据",
                "辟谣与证据梳理永久留档，拒绝二次炒作",
              ].map((t) => (
                <li
                  key={t}
                  className="flex items-start gap-3 text-foreground-700 text-sm md:text-base"
                >
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              读者怎么说
            </h3>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-1 gap-4">
              {quotes.map((q) => (
                <figure
                  key={q.name}
                  className="rounded-md bg-background-100/70 border border-background-200 p-4"
                >
                  <div className="flex items-center gap-1 text-accent-500 text-sm">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                    <span className="ml-auto text-xs text-foreground-600 font-medium">
                      认可度 {q.score}%
                    </span>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">
                    “{q.text}”
                  </blockquote>
                  <figcaption className="mt-3 text-xs text-foreground-600">
                    <span className="font-medium text-foreground-900">{q.name}</span>
                    <span className="mx-2">·</span>
                    {q.role}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}